 <template lang="html">
   <div class="test-form">
      <Delete :delete_message="delete_message" :show="show_delete_modal" @close="$store.commit('show_delete_modal',false)" @delete="deleteUser()"/>

      <Modal :show="show_create_modal" content_class="col-12 col-md-9 col-lg-8 col-xl-7" @close="$store.commit('show_create_modal',false)">
         <template slot="title">
            <div class="title">{{User.forms.addUser.title}}</div>
            <div class="subtitle">{{User.forms.addUser.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="User.forms.addUser.name" 
                  :forms="User.forms.addUser.forms" 
                  :form_data="User.forms.addUser.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="addUser({ref: $refs[User.forms.addUser.name]})" :disabled="loading">
                     Create <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Modal :show="show_edit_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">{{User.forms.editUser.title}}</div>
            <div class="subtitle">{{User.forms.editUser.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="User.forms.editUser.name" 
                  :forms="User.forms.editUser.forms" 
                  :form_data="User.forms.editUser.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="editUser({ref: $refs[User.forms.editUser.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <div class="top-actions clearfix">
         <div class="btn btn-primary btn-r" @click="$store.commit('show_create_modal',true)">
            Add User <i class="fa fa-plus"></i>
         </div>
      </div>

      <Table v-bind="User.tables.users.props" :data="users" @on-action="handleActions"/>
   </div>
</template>

<script>
import user from "./user.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('user')
      Event.$off('form:submit_update');
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('user',user,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
      // Table: () => import("clarks/components/table/table"),
   },
   computed: {
      ...mapGetters([
         'User',
         'users',
         'show_create_modal',
         'show_edit_modal',
         'loading',
         'delete_message',
         'show_delete_modal',
      ])
   },
   methods: {
      ...mapActions([
         'fetchFormData',
         'fetchData',
         'addUser',
         'editUser',
         'updateUser',
         'handleActions',
         'deleteUser',
      ]),
   },
   async mounted(){
      utils.registerModule('user',user,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .test-form{
      
   }
</style>